import Rails from "@rails/ujs"
import { Controller } from "stimulus";
import {error} from "autocomplete.js/src/common/utils";

function validate_email(email) {
  var regex = /^([a-zA-Z0-9._+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function skipObjectIfExists(optionObject, value) {
  return $(optionObject).find('option[value=' + value + ']').length > 0;
}

function validate_phone(phone) {
  return (phone.replace(/[_-]/gi, '').length == 10);
}

function correctDateFormat(date) {
  return date.toLocaleDateString();
  return moment(date).format('MM/DD/YYYY h:mm:ss A');
}

function getDateInterval(from, to) {
  var res = '';
  if (from != null) {
    res += " from " + correctDateFormat(from);
  }

  if (to != null) {
    res += " until " + correctDateFormat(to);
  }
  return res;
}

function addAlert(element, alert, isError = true) {
  let alertClass = (isError ? 'text-danger' : 'text-info');
  let alertHtml = '<small class="'+alertClass+'">' + alert + '</small>';
  $(element).closest('.form-group').find('small').remove();
  $(element).closest('input').after(alertHtml);
  if (isError) {
    $(element).closest('.form-group').addClass('has-error');
  }
}

function removeAlert(element) {
  $(element).closest('.form-group').removeClass('has-error');
  $(element).closest('.form-group').find('small').remove();
}

export default class extends Controller {
  static targets = ["school", "instructor", "semester", "course", "accessCode", "username",
                    "password", "confirmPassword", "firstName", "lastName", "email", "confirmEmail", "phone", "terms", "submit",
                    "verificationContainer", "sendCodeButton", "sendCodeResult", "emailCode"];

  initialize() {
  }

  updateTerms(event) {
    let termsTarget = this.termsTarget;
    let submitTarget = this.submitTarget;

    if (termsTarget.checked) {
      submitTarget.disabled = false;
    } else {
      submitTarget.disabled = true;
    }
  }

  updatePhone(event) {
    let phoneTarget = this.phoneTarget;
    let termsTarget = this.termsTarget;

    if (validate_phone(phoneTarget.value)) {
      $(phoneTarget).siblings('.form-text.text-muted').hide();
      termsTarget.disabled = false;
    } else {
      $(phoneTarget).siblings('.form-text.text-muted').show();
      termsTarget.disabled = true;
    }
  }

  updateConfirmEmail(event) {
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;

    if (validate_email(emailTarget.value) && emailTarget.value == confirmEmailTarget.value) {
      phoneTarget.disabled = false;
    } else {
      phoneTarget.disabled = true;
    }
  }

  updateEmail(event) {
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;

    let locked = $(emailTarget).data('locked') == '1';

    if (validate_email(emailTarget.value) && !locked) {
      confirmEmailTarget.disabled = false;
    } else {
      confirmEmailTarget.disabled = true;
    }
  }

  updateLastName(event) {
    let lastNameTarget = this.lastNameTarget;
    let emailTarget = this.emailTarget;

    if (lastNameTarget.value.length >= 1) {
      emailTarget.disabled = false;
    } else {
      emailTarget.disabled = true;
    }
  }

  updateFirstName(event) {
    let firstNameTarget = this.firstNameTarget;
    let lastNameTarget = this.lastNameTarget;

    if (firstNameTarget.value.length >= 1) {
      lastNameTarget.disabled = false;
    } else {
      lastNameTarget.disabled = true;
    }
  }

  updateConfirmPassword(event) {
    let passwordTarget = this.passwordTarget;
    let confirmPasswordTarget = this.confirmPasswordTarget;
    let firstNameTarget = this.firstNameTarget;

    if (confirmPasswordTarget.value.length > 0) {
      $(confirmPasswordTarget).siblings('.input-group-append').show();
      if ($('#student_confirm_password').attr('type') == 'text') {
        $('#c-password-visibility-true').addClass("d-none");
        $('#c-password-visibility-false').removeClass("d-none");
      } else {
        $('#c-password-visibility-true').removeClass("d-none");
        $('#c-password-visibility-false').addClass("d-none");
      }
    } else {
      $(confirmPasswordTarget).siblings('.input-group-append').hide();
      $('#c-password-visibility-true').addClass("d-none");
      $('#c-password-visibility-false').addClass("d-none");
    }

    if (passwordTarget.value.length >= 8 && passwordTarget.value == confirmPasswordTarget.value) {
      firstNameTarget.disabled = false;
    } else {
      firstNameTarget.disabled = true;
    }
  }

  updatePassword(event) {
    let passwordTarget = this.passwordTarget;
    let confirmPasswordTarget = this.confirmPasswordTarget;

    if (passwordTarget.value.length > 0) {
      $(passwordTarget).siblings('.input-group-append').show();
      if ($('#student_password').attr('type') == 'text') {
        $('#password-visibility-true').addClass("d-none");
        $('#password-visibility-false').removeClass("d-none");
      } else {
        $('#password-visibility-true').removeClass("d-none");
        $('#password-visibility-false').addClass("d-none");
      }
    } else {
      $(passwordTarget).siblings('.input-group-append').hide();
      $('#password-visibility-true').addClass("d-none");
      $('#password-visibility-false').addClass("d-none");
    }

    if (passwordTarget.value.length >= 8) {
      confirmPasswordTarget.disabled = false;
    } else {
      confirmPasswordTarget.disabled = true;
    }
  }

  updateUsername(event) {
    let usernameTarget = this.usernameTarget;
    let passwordTarget = this.passwordTarget;

    if (usernameTarget.value.length >= 5) {
      passwordTarget.disabled = false;
    } else {
      passwordTarget.disabled = true;
    }
  }

  updateEmailCode(event) {
    let emailCodeTarget = this.emailCodeTarget;
    let phoneTarget = this.phoneTarget;

    if (emailCodeTarget.value.length == 10) {
      phoneTarget.disabled = false;
    }
    else {
      phoneTarget.disabled = true;
    }
  }

  sendCode(event) {
    let emailTarget = this.emailTarget;
    let usernameTarget = this.usernameTarget;
    let sendCodeResultTarget = this.sendCodeResultTarget;
    let emailCodeTarget = this.emailCodeTarget;

    if (validate_email(emailTarget.value)) {
      let data = new FormData();
      data.append('username', usernameTarget.value);
      data.append('email', emailTarget.value);

      Rails.ajax({
        url: '/email_verification_codes/send_code',
        type: "POST",
        data: data,
        success: (data) => {
          if (data.success) {
            sendCodeResultTarget.innerHTML = "Verification code has been sent to the email address associated with your account";
            emailCodeTarget.disabled = false
          } else {
            sendCodeResultTarget.innerHTML = "This email address is not associated with your account. Please contact support at <a href=\"mailto:support@connect4education.com\">support@connect4education.com</a>";
            emailCodeTarget.disabled = true
          }
        }
      })
    }

    event.preventDefault();
  }

  checkEmail(event) {
    let usernameTarget = this.usernameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;

    let existingUser = $(usernameTarget).data('existing-user');

    if (!existingUser && validate_email(emailTarget.value)) {
      let data = new FormData();
      data.append('field', 'email');
      data.append('value', emailTarget.value);

      Rails.ajax({
        url: '/api/check_moodle_field',
        type: "POST",
        data: data,
        success: (data) => {
          if (data.exists) {
            addAlert(emailTarget, 'This email is already associated with an account under a different username')
            confirmEmailTarget.disabled = true;
          } else {
            removeAlert(emailTarget)
            confirmEmailTarget.disabled = false;
          }
        }
      })
    } else {
      confirmEmailTarget.disabled = true;
    }
  }

  checkUsername(event) {
    let usernameTarget = this.usernameTarget;
    let emailTarget = this.emailTarget;
    let verificationContainerTarget = this.verificationContainerTarget;

    let data = new FormData();
    data.append('field', 'username');
    data.append('value', usernameTarget.value);

    Rails.ajax({
      url: '/api/check_moodle_field',
      type: "POST",
      data: data,
      success: (data) => {
        if (data.exists) {
          let errorMessage = "Username already exists. Please choose a different username or enter your email address below to verify your account.";
          addAlert(usernameTarget, errorMessage, false);
          verificationContainerTarget.hidden = false;
          emailTarget.disabled = false;
          $(usernameTarget).data('existing-user', true);

          $('[data-new-user-field="1"]').each(function() {
            $(this).closest('.form-group').hide();
          });
        } else {
          removeAlert(usernameTarget);
          verificationContainerTarget.hidden = true;
          emailTarget.disabled = true;
          $(usernameTarget).data('existing-user', false);

          $('[data-new-user-field="1"]').each(function() {
            $(this).closest('.form-group').show();
          });
        }
      }
    })
  }

  updateAccessCode(event) {
    let accessCodeTarget = this.accessCodeTarget;
    if (accessCodeTarget.value.length < 3) {
      return;
    }
    let courseTarget = this.courseTarget;
    let usernameTarget = this.usernameTarget;

    let data = new FormData();
    data.append('access_code', accessCodeTarget.value);
    data.append('course_request_id', courseTarget.value);

    Rails.ajax({
      url: '/access_codes/verify',
      type: "POST",
      data: data,
      success: (data) => {
        if (!data.valid) {
          if (data.access_code_error) {
            addAlert(accessCodeTarget, data.access_code_error);
            usernameTarget.disabled = true;
          }
        } else {
          removeAlert(accessCodeTarget);
          usernameTarget.disabled = false;
        }
      }
    })
  }

  updateSchool(event) {
    let school = this.schoolTarget.value;
    let instructor = this.instructorTarget;
    instructor.value = null;

    if (school == ''){
      $('#student_student_enrollment_school_id').siblings('.form-text.text-muted').show();
    } else {
      $('#student_student_enrollment_school_id').siblings('.form-text.text-muted').hide();
    }

    this.clearSemester()
    this.clearCourse()
    this.clearInstructor()

    let instructors = select_data.filter(function(el){ return el[3][1] == school })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Instructor...";
    instructor.appendChild(opt);
    instructors.forEach(function(el){
      if (skipObjectIfExists(instructor, el[1][1])) return;
      var opt = document.createElement('option');
      opt.value = el[1][1];
      opt.innerHTML = el[1][0];
      instructor.appendChild(opt);
    })

    instructor.disabled = !school;
  }


  updateInstructor(event) {
    let semester = this.semesterTarget;
    let instructor = this.instructorTarget.value;
    let school = this.schoolTarget.value;

    this.clearSemester()
    this.clearCourse()


    let semesters = select_data.filter(function(el){ return el[3][1] == school && el[1][1] == instructor })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Semester...";
    semester.appendChild(opt);
    semesters.forEach(function(el){
      if (skipObjectIfExists(semester, el[2][1])) return;
      var opt = document.createElement('option');
      opt.value = el[2][1];
      opt.innerHTML = el[2][0];
      semester.appendChild(opt);
    })

    semester.disabled = !instructor;
  }

  updateSemester(event) {
    let course = this.courseTarget;
    let semester = this.semesterTarget.value;
    let instructor = this.instructorTarget.value;
    let school = this.schoolTarget.value;

    this.clearCourse()

    let courses = select_data.filter(function(el){ return el[3][1] == school && el[1][1] == instructor && el[2][1] == semester  })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Course...";
    course.appendChild(opt);
    courses.forEach(function(el){
      var opt = document.createElement('option');
      opt.value = el[0][1];
      opt.innerHTML = el[0][0];
      course.appendChild(opt);
    })

    course.disabled = !semester;

  }

  updateCourse(event){
    let course = this.courseTarget.value;
    let accessCodeTarget = this.accessCodeTarget;
    let course_value = select_data.filter(function(el){ return el[0][1] == course })[0];

    let start_date = new Date(course_value[0][3].replace(/\-/g,'\/').replace(/[T|Z]/g,' '));
    let end_date = new Date(course_value[0][4].replace(/\-/g,'\/').replace(/[T|Z]/g,' '));
    let course_end_date = new Date(course_value[0][5].replace(/\-/g,'\/').replace(/[T|Z]/g,' '));
    let current_date = new Date();
    let isSuccess = true;
    let errorMessage = ''

    if (start_date != null && current_date < start_date) {
      isSuccess = false;
      errorMessage = 'The registration period for this course has not started yet. The registration period runs:' + getDateInterval(start_date, end_date) + '. Should you require further assistance, please contact your instructor';
    } else if (end_date != null && current_date > end_date) {
      isSuccess = false;
      errorMessage = 'The registration period for this course has ended. The registration period runs:' + getDateInterval(start_date, end_date) + '. Should you require further assistance, please contact your instructor.';
    } else if (start_date != null && end_date != null && course_end_date && course_end_date < current_date) {
      isSuccess = false;
      errorMessage = 'This course has ended. Should you require further assistance, please contact Connect4Education Technical Support at 703-880-1180 x200 or <a href="mailto:support@connect4education.com">support@connect4education.com</a>';
    }

    if (isSuccess) {
      if (course_value[0][2] == 'no_lti' || course_value[0][2] == ''){
        $('.lti-course-message').hide();
        $('.registration-details').show();
        accessCodeTarget.disabled = false;
      }
      else {
        $('.lti-course-message').show();
        $('.registration-details').hide();
      }
      $('.registration-date-message').hide();
    } else {
      $('.registration-date-message').html(errorMessage);
      $('.registration-date-message').show();
      $('.registration-details').hide();
    }
  }

  clearInstructor(){
    let school = this.schoolTarget.value;
    let instructor = this.instructorTarget;
    instructor.value = '';
    instructor.disabled = true;
    instructor.innerHTML = '';
    return true;
  }

  clearSemester(){
    let instructor = this.instructorTarget;
    let semester = this.semesterTarget;
    semester.value = null;
    semester.disabled = true;
    semester.innerHTML = '';
  }

  disableRemainingFields() {
    $('.registration-details input').attr('disabled', 'disabled');
  }

  clearCourse(){
    let semester = this.semesterTarget;
    let course = this.courseTarget;
    course.value = null;
    course.disabled = true;
    course.innerHTML = '';
    this.disableRemainingFields();
  }
}
